<div id="serverInfo" [ngStyle]="{'background': 'url(' + '/assets/images/backgrounds/' + months[monthIndex] +'.jpg)'}"
     fxLayout="column" fusePerfectScrollbar>
  <div class="message-container">
    <img src="assets/images/server-maintence.png">
  </div>
</div>
